import React, { FC, useLayoutEffect, useState } from 'react';

import { ContentLayoutLoader } from './ContentLayoutLoader';
import { SideNavigationLayoutLoader } from './SideNavigationLayoutLoader';
import { TopNavigationLayoutLoader } from './TopNavigationLayoutLoader';

export const PROJECT_DIRECTORY_LAYOUT_STATIC_PATHNAMES = [
  '/home',
  '/projects',
  '/projects/templates',
];

export const FullPageLayoutLoader: FC = () => {
  const [showSideNavigation, setShowSideNavigation] = useState(true);

  useLayoutEffect(() => {
    const url = new URL(window.location.href);
    if (PROJECT_DIRECTORY_LAYOUT_STATIC_PATHNAMES.includes(url.pathname)) {
      setShowSideNavigation(false);
    }
  }, []);

  return (
    <TopNavigationLayoutLoader>
      {showSideNavigation ? <SideNavigationLayoutLoader /> : null}
      <ContentLayoutLoader />
    </TopNavigationLayoutLoader>
  );
};
